import { createContext } from 'react';

import { AppRoutes } from './pages/app-routes';
import { AppProviders } from './providers/app-providers';

export interface AppContextInterface {
  AppProviders: typeof AppProviders;
  AppRoutes: typeof AppRoutes;
}

const defaultValue: AppContextInterface = {
  AppProviders,
  AppRoutes,
};

export const AppContext = createContext<AppContextInterface>(defaultValue);
